import { Button } from './Button';

export { Button };

export default Button;
